module.exports = __webpack_public_path__ + "img/BISCAYNE.9d12034d.png";